import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Widerrufsrecht from "./pages/Widerrufsrecht";
import AGB from "./pages/AGB";
import NewsDetail from "./pages/NewsDetail";
import ScrollToTop from "./components/utils/ScrollToTop";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import ProtectedAdminRoute from "./admin/ProtectedAdminRoute";
import AdminContactSettings from "./admin/AdminContactSettings";
import AdminNewsList from "./admin/news/AdminNewsList";
import AdminNewsForm from "./admin/news/AdminNewsForm";
import AdminSiteNoticeSettings from "./admin/AdminSiteNoticeSettings";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />

            <Routes>
                <Route
                    path="/"
                    element={
                        <>
                            <Header />
                            <Home />
                            <Footer />
                        </>
                    }
                />

                <Route
                    path="/aktuelles/:slug"
                    element={
                        <>
                            <Header />
                            <NewsDetail />
                            <Footer />
                        </>
                    }
                />

                <Route
                    path="/impressum"
                    element={
                        <>
                            <Header />
                            <Impressum />
                            <Footer />
                        </>
                    }
                />

                <Route
                    path="/datenschutz"
                    element={
                        <>
                            <Header />
                            <Datenschutz />
                            <Footer />
                        </>
                    }
                />

                <Route
                    path="/widerrufsrecht"
                    element={
                        <>
                            <Header />
                            <Widerrufsrecht />
                            <Footer />
                        </>
                    }
                />

                <Route
                    path="/agb"
                    element={
                        <>
                            <Header />
                            <AGB />
                            <Footer />
                        </>
                    }
                />

                <Route path="/admin/login" element={<AdminLogin />} />

                <Route
                    path="/admin"
                    element={
                        <ProtectedAdminRoute>
                            <AdminLayout />
                        </ProtectedAdminRoute>
                    }
                >
                    <Route index element={<AdminDashboard />} />

                    <Route path="news" element={<AdminNewsList />} />
                    <Route path="news/new" element={<AdminNewsForm />} />
                    <Route path="news/:id" element={<AdminNewsForm />} />

                    <Route path="contact" element={<AdminContactSettings />} />
                    <Route path="notice" element={<AdminSiteNoticeSettings />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;